import { useShallow } from 'zustand/react/shallow'

import { Controls } from './Controls'
import { useCADPageStore } from '@/state'
import { CreateViewButton } from './CreateViewButton'
import { RetakeViewButton } from './CreateViewButton/RetakeViewButton'

export const ControlPanel = () => {
  const isRetakeModeActive = useCADPageStore(
    useShallow((state) => state.isRetakeModeActive),
  )

  return (
    <div
      className="absolute bottom-0 z-20 pointer-events-auto select-none"
      style={{ right: 0, left: 0, bottom: 40, transform: 'none !important' }}
    >
      <div className="flex justify-center bg-transparent w-full">
        <div className="flex items-center space-x-1 py-0 pl-4 pr-1 border shadow-md rounded-full bg-white">
          <Controls />
          {isRetakeModeActive ? <RetakeViewButton /> : <CreateViewButton />}
        </div>
      </div>
    </div>
  )
}
